export default () => import('@owc-packages/ValidationBox/src/ValidationBoxWrapper.vue');
